export const PRIMARY_BACKGROUND = '#FCF9F0';
export const PRIMARY_COLOR = '#FAA004';
export const SECONDARY_COLOR = '#0485fd';

export const ORANGE_LINE = "https://res.cloudinary.com/dttau3gcw/image/upload/v1621438732/Group_ziygqh.png";
export const GREEN_ENVELOPE = "https://res.cloudinary.com/dttau3gcw/image/upload/v1621439286/Group_1334_m9xdhx.png";
export const RECTANGLE_BANNER = "https://res.cloudinary.com/dttau3gcw/image/upload/v1621445994/Rectangle_14_nftzwa.png";

export const MIXPANEL_TOKEN = "d6ab5dd3cabeff906f074e0597893d7d"
export const PROD_MIXPANEL_TOKEN = "2779283b3021a3ae56509faad99ea2fd"